// hooks/useToggle.ts
import axios from "axios";
import Cookies from 'universal-cookie';

// Set global defaults for Axios
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.withCredentials = true; 

const checkCookieExists = (name: string) => {
  return document.cookie.split(';').some((item) => item.trim().startsWith(`${name}=`));
};

export const SetSessionID = (sid: string): void => {
    const cookies = new Cookies();
    cookies.set('app-session', sid, { path: '/' });
};

export const GetSessionID = (): string => {
    const cookies = new Cookies();
    return cookies.get('app-session');
};

export const ClearCookies = (): void => {
    const cookies = new Cookies();
    // Remove targeted cookies
    cookies.remove('app-session', { path: '/' });
    cookies.remove('csrftoken', { path: '/' });
};